// extracted by mini-css-extract-plugin
export var measureBox = "_p-0";